/* CUSTOM CODE */
jQuery(document).ready(function ($) {
  // $('.your_cart_item_count').prependTo('.cart-content-left');
   // Hide the element initially
      $('.your_cart_item_count').hide();

      // Move the element inside .cart-content-left at the beginning
      $('.your_cart_item_count').prependTo('.cart-content-left');

      // Show the element after moving it
      $('.your_cart_item_count').show();
    function initializeTimerAndPopup() {
      // Check if the timer should start on the next page refresh
// Check if the timer should start on the next page refresh
if (localStorage.getItem("startTimerOnRefresh") =='true') {
  //console.log(localStorage.getItem("startTimerOnRefresh") )
    // Reintroduce a 1-minute timer at the next step
    // You may need to adjust this part based on your specific logic for introducing the 1-minute timer
    // For now, I'll set it to start in 30 seconds
    targetTime = new Date().getTime() + (15 * 60 * 1000);
    localStorage.setItem("targetTime", targetTime);

    // Set localStorage "startTimerOnRefresh" to "false"
    localStorage.setItem("startTimerOnRefresh", "false");

    // Start the 1-minute timer
    countdownInterval = setInterval(function () {
        updateTimer($timerMinutesElement1, $timerSecondsElement1);
        updateTimer($timerMinutesElement2, $timerSecondsElement2);
    }, 1000);
} 
      //console.log('Initializing timer and popup...');
        //console.log('*************');
        var countdownInterval;

        function updateTimer($timerMinutesElement, $timerSecondsElement) {
        // Check if it's the first time initializing the timer
        var isFirstTime = localStorage.getItem("isFirstTime") !== "false";
        
        // Get the target time from localStorage or set a new one
        var storedTargetTime = localStorage.getItem("targetTime");
        
        // Set the target time to the current time plus 1 minute if it's not present in localStorage or it's the first time
        var targetTime;
        if (isFirstTime || !storedTargetTime) {
            targetTime = new Date().getTime() + (15 * 60 * 1000);
        
            // Set isFirstTime flag to false after the first initialization
            localStorage.setItem("isFirstTime", "false");
        } else {
            targetTime = parseInt(storedTargetTime, 10);
        }
        
        // Save the target time in localStorage
        localStorage.setItem("targetTime", targetTime);
        
        // Calculate timeLeft
        var timeLeft = targetTime - new Date().getTime();
          //console.log('--------')
          //console.log(targetTime)
          //console.log(new Date().getTime())
          
          //console.log('--------')
            // Now you can use timeLeft in your existing code
            if (timeLeft <= 0) {
                // Rest of your existing code for handling timer expiration
                clearInterval(countdownInterval);
                $timerMinutesElement.text("00");
                $timerSecondsElement.text("00");
                localStorage.setItem("popupShown", "false");
            
                setTimeout(function () {
                    var popupShown = localStorage.getItem("popupShown");
                    if (popupShown === undefined || popupShown === 'false') {
                        targetTime = new Date().getTime() + (15 * 60 * 1000);
                        localStorage.setItem("targetTime", targetTime);
                        
                        // Clear existing interval
                        clearInterval(countdownInterval);
                        
                        // Start the timer in reverse direction
                        countdownInterval = setInterval(function () {
                          updateTimer($timerMinutesElement1, $timerSecondsElement1);
                          updateTimer($timerMinutesElement2, $timerSecondsElement2);
                        }, 1000);
                        // Set localStorage "popupShown" to "true"
                        localStorage.setItem("popupShown", "true");
                    }
                }, 1000);
            } else {
                // Rest of your existing code for updating the timer
                var minutes = Math.floor(timeLeft / (60 * 1000));
                var seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);
            
                var minutesString = (minutes < 10 ? "0" : "") + minutes;
                var secondsString = (seconds < 10 ? "0" : "") + seconds;
            
                $timerMinutesElement.text(minutesString);
                $timerSecondsElement.text(secondsString);
            }
        }

        // Function to show the confirmation popup
        function showConfirmationPopup() {
            if ($('#confirmationModal').length > 0) {
                //console.log('Popup already exists. Skipping...');
                return;
            }
            // Create a modal element
            var modal = $('<div class="modal fade" id="confirmationModal" style="z-index:9999999991;" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">' +
                '<div class="timer-poup modal-dialog" role="document" style="max-width:100%; height: 100%; position: relative; top:0; display: flex; align-items: center; justify-content: center;">' +
                '<div class="modal-content">' +
                '<div class="modal-header">' +
                '<h5 class="modal-title" id="exampleModalLabel"><img src="https://cdn.shopify.com/s/files/1/0562/7569/7706/t/74/assets/Shopping%20cart.png?v=1699596999"/>Oops! <br/>Your cart has expired.</h5>' +
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                'Do you want the items to be reserved for another 15 minutes?”' +
                '</div>' +
                '<div class="modal-footer">' +
                '<a href="javascript:void(0)" id="yesButton" type="button" class="btn btn-secondary" data-dismiss="modal">Yes</a>' +
                '<a href="javascript:void(0)" id="noButton" type="button" class="btn btn-secondary" data-dismiss="modal">No</a>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>');

            // Append the modal to the body
            $('body').append(modal);

            // Show the modal
            modal.modal('show');

            // Remove the modal from the DOM after it is hidden
            modal.on('hidden.bs.modal', function () {
                modal.remove();
            });

            // Add click event handlers for "Yes" and "No" buttons
            modal.find('#yesButton').one('click', function () {
                // Set the target time to the current time plus 1 minute
                targetTime = new Date().getTime() + (15 * 60 * 1000);
                localStorage.setItem("targetTime", targetTime);

                // Clear existing interval
                clearInterval(countdownInterval);

                // Start the timer in reverse direction
                countdownInterval = setInterval(function () {
                    updateTimer($timerMinutesElement1, $timerSecondsElement1);
                    updateTimer($timerMinutesElement2, $timerSecondsElement2);
                }, 1000);
              // Set localStorage "popupShown" to "true"
    localStorage.setItem("popupShown", "true");
            });

            modal.find('#noButton').one('click', function () {
                // Remove the timer at the exact step they are
                clearInterval(countdownInterval);
                $timerElement1.hide(); // Hide the timer
                $timerElement2.hide(); // Hide the timer

                // Clear existing interval
                clearInterval(countdownInterval);
              // Set the target time to the current time plus 1 minute
                targetTime = new Date().getTime() + (15 * 60 * 1000);
                localStorage.setItem("targetTime", targetTime);

                // Clear existing interval
                clearInterval(countdownInterval);

                // Start the timer in reverse direction
                countdownInterval = setInterval(function () {
                    updateTimer($timerMinutesElement1, $timerSecondsElement1);
                    updateTimer($timerMinutesElement2, $timerSecondsElement2);
                }, 1000);

              // Set a flag to indicate that the timer should start on the next page refresh
    localStorage.setItem("startTimerOnRefresh", "true");

    // Set localStorage "popupShown" to "true" to prevent showing the popup immediately
    localStorage.setItem("popupShown", "true");
            });

          // modal.on('click', '[data-dismiss="modal"]', function () {
            $('.close').click(function(){
              // Trigger the "No" button click event
              modal.find('#noButton').click();
          });
          // Add click event to close the popup when clicking outside the modal
            // $(document).on('click', function (event) {
            //     if ($(event.target).closest('#confirmationModal').length === 0) {
            //         // Clicked outside the modal, trigger the "No" button click event
            //         modal.find('#noButton').click();
            //     }
            // });
          // Specify the specific element
          var specificElement = $('#confirmationModal .timer-poup .modal-content');
    
          // Click event on the document
          $(document).on('click', function(event) {
            // Check if the clicked element is not within the specific element
            if (!specificElement.is(event.target) && !specificElement.has(event.target).length) {
              // Perform your action here
              modal.find('#noButton').click();
              //console.log('Clicked outside the specific element');
            }
          });
        }

        // Get the target time from localStorage or set a new one
        var storedTargetTime = localStorage.getItem("targetTime");

        // Set the target time to the current time plus 1 minute if it's not present in localStorage
        var targetTime = storedTargetTime ? parseInt(storedTargetTime, 10) : new Date().getTime() + (15 * 60 * 1000);

        // Save the target time in localStorage
        localStorage.setItem("targetTime", targetTime);

        // Create the timer elements
        var $timerElement1 = $("<div class='timer-wrapper-global'><div class='high-deman-wrapper'><p>These products are in high demand</p></div><div class='timer'><p>Your cart is reserved for</p><div id='timer1'><span id='minutes1'>00</span>:<span id='seconds1'>00</span></div></div></div>");
        var $timerElement2 = $("<div class='timer-wrapper-global'><div class='high-deman-wrapper'><p>These products are in high demand</p></div><div class='timer'><p>Your cart is reserved for</p><div id='timer2'><span id='minutes2'>00</span>:<span id='seconds2'>00</span></div></div></div>");

        // Append the timer elements to your existing content, but hide them initially
        $timerElement1.hide();
        $timerElement2.hide();
        $(".your_cart_item_count").before($timerElement1);
        $(".custom_mini_cart_total").before($timerElement2);

        // Select the timer elements where you want to update the countdown timer text
        var $timerMinutesElement1 = $timerElement1.find("#minutes1");
        var $timerSecondsElement1 = $timerElement1.find("#seconds1");
        var $timerMinutesElement2 = $timerElement2.find("#minutes2");
        var $timerSecondsElement2 = $timerElement2.find("#seconds2");

        // Check if the Shopify cart is empty
        $.getJSON('/cart.js', function (cart) {
            if (cart.item_count > 0) {
                if(!localStorage.getItem("popupShown")){
                  // showConfirmationPopup();                
                }
                $timerElement1.show();
                $timerElement2.show(); // Show the first timer if the cart is not empty
                updateTimer($timerMinutesElement1, $timerSecondsElement1); // Initialize and update the first timer
                countdownInterval = setInterval(function () {
                    updateTimer($timerMinutesElement1, $timerSecondsElement1);
                    updateTimer($timerMinutesElement2, $timerSecondsElement2);
                }, 1000); // Update every 1 second
            }
        });
    }

    initializeTimerAndPopup();

    $('.product_detail_custom_add_to_cart').on('click', function () {
        //console.log('999999999999999');
        
        // Check if the timer is already initialized
        if (!localStorage.getItem("isTimerInitialized") != 'true') {
            // Set a flag to indicate that the timer is initialized
            localStorage.setItem("isTimerInitialized", "true");
            //console.log('7777777777777777777777777')
          // Remove existing timer elements
        $('.timer-wrapper-global').remove();
          // Reset the timer by removing the existing targetTime
        localStorage.removeItem("targetTime");
            // Initialize the timer
            setTimeout(function () {
                initializeTimerAndPopup();
			// Select all timer elements
            var timerElements = document.querySelectorAll('.timer-wrapper-global');

			// Show only the last timer element and hide others
            if (timerElements.length > 1) {
              for (var i = 0; i < timerElements.length - 1; i++) {
                timerElements[i].style.visibility = 'hidden';
              }
              timerElements[timerElements.length - 1].style.visibility = 'visible';
              //console.log('multiples22222')
            }
            }, 1000);
        }
    });
});
